module.exports = __webpack_public_path__ + "media/4x3/uz-eb1e00b8.svg";